import React from "react";

const skills: string[] = ['English', 'PHP', 'SQL', 'Python', 'TypeScript', 'Go'];

export const Skills: React.FC = () => (
  <section className="mb-5">
    <h2>Languages</h2>
    <div className="ml-3">
      <p className="text-base">
        Languages I'm learning<br />
      <span className="text-gray-500">[{ skills.join(', ') }]</span>
      </p>
    </div>
  </section>
);
